import { useCountDown } from 'ahooks';
import classnames from 'classnames';
import React from 'react';
import dayjs, { utc2local } from '../_util/day';
import { pickDomAttrs } from '../_util/utils';
import { useConfig } from '../hooks/useConfig';
import Tooltip from '../tooltip';
import { getText } from './util';

//倒计时
import { jsx as _jsx } from "react/jsx-runtime";
export const CountDown = _ref => {
  let {
    targetDate,
    tooltip,
    level,
    format,
    onEnd,
    timeOutText,
    className,
    style,
    ...restProps
  } = _ref;
  const {
    locale: {
      Day: DayLocale
    }
  } = useConfig();
  const attrs = pickDomAttrs(restProps);
  const [countdown, formattedRes] = useCountDown({
    targetDate: targetDate,
    onEnd: targetDate && dayjs(targetDate).isAfter(dayjs()) ? onEnd : undefined
  });
  if (!targetDate) {
    return /*#__PURE__*/_jsx("span", {
      ...attrs.data,
      children: "-"
    });
  }
  const timedOut = countdown <= 0;
  const text = getText(formattedRes, DayLocale);
  const formattedText = format ? format({
    text,
    countdown,
    formattedRes
  }) : text;
  if (timedOut) {
    return /*#__PURE__*/_jsx("span", {
      ...attrs.data,
      className: classnames('countDown', level, className),
      style: style,
      children: timeOutText !== null && timeOutText !== void 0 ? timeOutText : formattedText
    });
  }
  const _tooltip = typeof tooltip === 'function' ? tooltip({
    text,
    countdown,
    formattedRes
  }) : tooltip;
  const tooltipProps = {
    title: utc2local(targetDate),
    ..._tooltip
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    ...tooltipProps,
    children: /*#__PURE__*/_jsx("span", {
      ...attrs.data,
      className: classnames('countDown', level, className),
      style: style,
      children: formattedText
    })
  });
};